<elcia-card [title]="'Information'">
  <div class="flex flex-col gap-4">

    <div class="flex gap-4">
      <div class="flex-1">
        <elcia-legal-entity-dropdown [control]="this.fg().controls.legalEntityId" [isMulti]="false"/>
      </div>
      <div class="flex-1">
        <elcia-date-picker [control]="this.fg().controls.invoiceDate" [label]="'invoice.invoice-date' | translate"
                           [minDate]="minInvoiceDate()"/>
      </div>
    </div>
    <div class="flex gap-4">
      <div class="flex-1">
        <elcia-party-dropdown (partySelected)="onCustomerSelected($event)"
                              [control]="this.fg().controls.customerId" [isMulti]="false"
                              [partyTypes]="this.partyTypes()"/>
      </div>
      <div class="flex-1">
        <elcia-local-dropdown [control]="this.fg().controls.localeIsoCode"/>
      </div>
    </div>
  </div>
</elcia-card>

<br>

<elcia-card [title]="'invoice.details' |translate">
  @if (canEditLines()) {
    <div class="flex flex-col gap-4">
      @for (invoiceLineForm of this.fg().controls.invoiceLines.controls; track $index) {
        <elcia-invoice-line-form
          (onRemove)="removeInvoiceLine($index)"
          (travelExpensesResolved)="onTravelExpensesResolved(invoiceLineForm, $event)"
          [customerId]="customerIdValue()"
          [fg]="invoiceLineForm"
          [invoiceDate]="invoiceDateValue()"
          [legalEntityId]="legalEntityIdValue()"
        />
      }
    </div>
    <p-divider/>
    <div class="flex justify-between">
      <div>
        <elcia-button (onClick)="addInvoiceLine()" [icon]="'plus'" [label]="'action.add-invoice-line' | translate"/>
      </div>
      <div class="w-2/6 py-2">
        <elcia-amount-recap [invoiceLines]="invoiceLineRecap()"/>
      </div>
    </div>
  } @else {
    <p class="text-sm text-surface-400 italic py-2">{{ 'invoice.lines-locked' | translate }}</p>
  }
</elcia-card>
<br>
<elcia-card [title]="'invoice.note' | translate">
  <elcia-editor [control]="this.fg().controls.note"/>
</elcia-card>
